'use client';

import { useState } from 'react';

import { StructuredDataFaq } from '@/services/structured-data-pages.service';

import styles from './Faq.module.scss';

type Props = {
  faqs: StructuredDataFaq[];
};

const Faq = ({ faqs }: Props) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  if (!faqs.length) {
    return null;
  }

  const handleToggle = (index: number) => {
    setOpenIndex((currentIndex) =>
      currentIndex === index ? null : index,
    );
  };

  return (
    <section
      className={styles.faq}
      aria-labelledby="faq-title"
    >
      <div className={styles.container}>
        <h2 id="faq-title" className={styles.title}>
          Frequently Asked Questions
        </h2>

        <div className={styles.list}>
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;

            const questionId = `faq-question-${index}`;
            const answerId = `faq-answer-${index}`;

            return (
              <div
                key={`${faq.question}-${index}`}
                className={`${styles.item} ${
                  isOpen ? styles.itemOpen : ''
                }`}
              >
                <button
                  type="button"
                  id={questionId}
                  className={styles.question}
                  aria-expanded={isOpen}
                  aria-controls={answerId}
                  onClick={() => handleToggle(index)}
                >
                  <span className={styles.questionText}>
                    {faq.question}
                  </span>

                  <span className={styles.icon} aria-hidden="true">
                    <svg
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M8 10L12 14L16 10" />
                    </svg>
                  </span>
                </button>

                <div
                  id={answerId}
                  className={styles.answerWrapper}
                  role="region"
                  aria-labelledby={questionId}
                  aria-hidden={!isOpen}
                >
                  <div className={styles.answer}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: faq.answer,
                      }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;